import RequestManager from "src/requests/RequestManager";
import { Comment } from "../interfaces";
import { ActionsTask } from "../tasks";
import { parseComment } from "../utils";
import { actions as resultMock, isMockDataActive } from "../mockData"

// Se utiliza en VCardPartido/Comentarios
export default async function getComments(matchId: string): Promise<Comment[]> {
    const task = new ActionsTask(matchId);

    let result;
    if(isMockDataActive) {
        result = resultMock;
    } else {
        result = await RequestManager.addRequest(task);
    }

    const actions = result.actions || [];

    const comments = actions.map((comment: any) => parseComment(comment))
    
    return comments;
}



// WEBPACK FOOTER //
// ./src/mundial/requests/api/getComments.ts